export function ParseIntAndFormat(value) {
    return parseInt(value).toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}